function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 26,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9094 7.69302L11.4575 18.3127H8.55333L6.36281 9.83927C6.23 9.31687 6.1149 9.12562 5.70937 8.90604C5.04885 8.54833 3.95802 8.21187 3 8.00292L3.06552 7.69479H7.74052C8.33552 7.69479 8.87208 8.09146 9.00667 8.77854L10.163 14.9233L13.0229 7.69479H15.9094V7.69302ZM27.287 14.8472C27.2994 12.044 23.4106 11.8899 23.4372 10.6379C23.446 10.2572 23.8091 9.85167 24.6024 9.74896C24.9955 9.6976 26.081 9.65865 27.3118 10.2235L27.7934 7.97104C27.1329 7.73198 26.2811 7.5 25.224 7.5C22.5075 7.5 20.5968 8.94323 20.5808 11.0116C20.5631 12.5398 21.9444 13.3933 22.9856 13.9016C24.057 14.4222 24.4165 14.7569 24.4111 15.2208C24.4041 15.9327 23.5576 16.2479 22.766 16.2603C21.3848 16.2816 20.5844 15.8867 19.9451 15.5892L19.4475 17.916C20.0885 18.21 21.275 18.4668 22.5022 18.4809C25.3904 18.4809 27.2781 17.0554 27.287 14.8472ZM34.4589 18.3145H37L34.7811 7.69302H32.4366C31.9089 7.69302 31.4644 7.99937 31.2678 8.47219L27.1453 18.3127H30.03L30.6038 16.726H34.1277L34.4589 18.3145ZM31.3935 14.5515L32.8403 10.5635L33.6726 14.5515H31.3935ZM19.8335 7.69302L17.5616 18.3127H14.815L17.087 7.69302H19.8335Z",
  fill: "#1434CB"
});

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.a0733d64.svg";
export { ForwardRef as ReactComponent };